// Author YuJiaBei
// Date 2020-02-28 14:10

import * as model from "@/model/em/inspection/InspectionRecordForInspectionModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.InspectionRecordForInspection(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_INSPECTION_URL
})
    .buildStore()
